(window.GridView = function ($, Behaviors) {

  "use strict";

  /*function hideLastItem(){
    const gridItems = document.querySelectorAll(".grid-item");
    if(!Number.isInteger(gridItems.length / parseInt(window.localStorage.getItem('collection-grid-desktop')))){
      //not full number
      const plumb = parseFloat('0.'+((gridItems.length / parseInt(window.localStorage.getItem('collection-grid-desktop'))).toString().split('.')[1]));
      let itemsToHide = parseInt(plumb * parseInt(window.localStorage.getItem('collection-grid-desktop')));
      if(itemsToHide){
        for(let i = gridItems.length - 1; i > 0; i--){
          const gridItem = gridItems[i];
          if(itemsToHide > 0){
            gridItem.style.display = 'none';
            itemsToHide--;
          }else{
            gridItem.style.display = '';
          }
        }
      }
    }else{
      for(let i = gridItems.length - 1; i > 0; i--){
        const gridItem = gridItems[i];
        gridItem.style.display = '';
      }
    }
  }*/

  function applyGrid (gridContainer, observer){
    if(observer){
      observer.disconnect();
    }
    if(!window.localStorage.getItem('collection-grid-desktop')){
      window.localStorage.setItem('collection-grid-desktop', '4');
    }
    if(!window.localStorage.getItem('collection-grid-mobile')){
      window.localStorage.setItem('collection-grid-mobile', '2');
    }

    const mobileGridButton = document.querySelector('.grid-change__item--active.mobile-only');
    const desktopGridButton = document.querySelector('.grid-change__item--active.desktop-only');

    if(window.innerWidth > 1024){
      document.querySelector('.product__list').dataset.grid = window.localStorage.getItem('collection-grid-desktop');
      if(desktopGridButton.dataset.grid !== window.localStorage.getItem('collection-grid-desktop')){
        desktopGridButton.classList.remove('grid-change__item--active');
        const activeDesktopGrid = document.querySelector('.desktop-only[data-grid="'+window.localStorage.getItem('collection-grid-desktop')+'"]');
        if(activeDesktopGrid){
          activeDesktopGrid.classList.add('grid-change__item--active');
        }
      }
    }else{
      document.querySelector('.product__list').dataset.grid = window.localStorage.getItem('collection-grid-mobile');
      if(mobileGridButton.dataset.grid !== window.localStorage.getItem('collection-grid-mobile')){
        mobileGridButton.classList.remove('grid-change__item--active');
        const activeMobileGrid = document.querySelector('.mobile-only[data-grid="'+window.localStorage.getItem('collection-grid-mobile')+'"]');
        if(activeMobileGrid){
          activeMobileGrid.classList.add('grid-change__item--active');
        }
      }
    }
    //hideLastItem();
    if(gridContainer && observer){
      window.collectionPaginationLinks = document.querySelectorAll('.pagination a');
      window.collectionPaginationLinks.length && window.collectionPaginationLinks.forEach(collectionPaginationLink => {
        collectionPaginationLink.addEventListener('click', () => {
          observer.observe(gridContainer, {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true
          });
        })
      })
    }
  }

  function GridView(elem) {
    Behaviors.init(GridView, this, arguments)

    this.GridButton = this.$elem[0].querySelectorAll('.js-grid');
    this.GridButton.forEach(item => {
      item.addEventListener('click', function(){
        document.querySelectorAll('.grid-change__item--active').forEach(item => {
          item.classList.remove('grid-change__item--active');
        });

        this.classList.add('grid-change__item--active');

        let grid = this.dataset.grid;
        if(this.classList.contains('mobile-only')){
          window.localStorage.setItem('collection-grid-mobile', grid);
        }else if(this.classList.contains('desktop-only')){
          window.localStorage.setItem('collection-grid-desktop', grid);
        }
        document.querySelector('.product__list').dataset.grid = grid;
        //hideLastItem();
      });
    });

    window.addEventListener('load', () => {
      const gridContainer = document.querySelector(".collection-main__container");

      const observer = new MutationObserver( function(mutationsList, observer) {
        const timeout = setTimeout(() => {
          applyGrid(observer);
          clearTimeout(timeout)
        }, 1000);
      });

      applyGrid(gridContainer, observer);
    })

    $(document).on('click', '.js-filter-trigger', function(){
      $('.collection-main__sidebar').toggleClass('collection-main__sidebar--active');
      $(this).toggleClass('filter-trigger--active');

      $('.filter-menu').toggleClass('filter-menu--active');
    });

    $(document).on('click', '.js-filter-trigger-mobile', function(){
      $('#pt-nav-toggle').click();
    });

    document.querySelector('#view-pref').addEventListener('change', function(){
      let value = this.value;
      if (value == 'product') {
        document.querySelector('.collection-main__container').classList.add('collection-main__container--product');
      }else{
        document.querySelector('.collection-main__container').classList.remove('collection-main__container--product');
      }
    });

  }

  Behaviors.inherit(GridView, Behaviors.Behavior);
  GridView.QUERY = '.grid-change';

  Behaviors.register_behavior(GridView);

  return GridView;

}(window.jQuery, window.Behaviors));